import React from 'react';
import ListingsStats from '../../../tenant/common/components/listing/listingStats';

export const UnifiedPlatformListingStats = (props) => {
  const platformData = props?.[props?.slug] || {};
  const { disposition = {}, stats = {} } = platformData;

  return <ListingsStats disposition={disposition} stats={stats} {...props} />;
};

